<!--
  ~ Copyright (c) 1999 - 2019 Accorto, Inc. - All rights reserved.
  -->

<header class="slds-page-header slds-page-header_record-home">
  <div class="slds-page-header__row">
    <div class="slds-page-header__col-title">
      <div class="slds-media">

        <div class="slds-media__figure">
          <span *ngIf="ui.iconHref?.includes('#')"
                [ngClass]="asString(ui.iconClass)"
                class="slds-icon_container">
            <svg aria-hidden="true" class="slds-icon slds-page-header__icon">
              <use [attr.xlink:href]="ui.iconHref"/>
            </svg>
          </span>
          <span *ngIf="ui.iconHref?.endsWith('.svg')"
                class="slds-avatar slds-avatar_medium">
            <img [alt]="ui.label" [src]="ui.iconHref"/>
          </span>
        </div>

        <div class="slds-media__body">
          <div class="slds-page-header__name">
            <div class="slds-page-header__name-title">
              <h1>
                <span>{{ui.label}}</span>
                <span [title]="record.labelName()" class="slds-page-header__title slds-truncate">{{record.labelName()}}</span>
              </h1>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="slds-page-header__col-actions">
      <div class="slds-page-header__controls">
        <div class="slds-page-header__control">
          <ul class="slds-button-group-list">
            <li>
              <button (click)="onClickDelete()" class="slds-button slds-button_neutral">Delete</button>
            </li>
            <li>
              <button class="slds-button slds-button_neutral">Clone</button>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div><!-- slds-page-header__row -->

  <!-- status -->
  <div class="slds-page-header__row">
    <div class="slds-page-header__col-meta">
      <acc-status-line [error]="error" [message]="message"></acc-status-line>
    </div>
  </div>
</header>

<section class="slds-card slds-p-horizontal_small slds-m-top_small slds-is-relative">
  <acc-form (saveRecord)="saveRecord($event)"
            (statusUpdate)="statusUpdate($event)"
            [record]="record"
            [ui]="ui"></acc-form>
  <acc-spinner *ngIf="busy"></acc-spinner>
</section>

<section>
  <div class="slds-tabs_scoped">
    <ul class="slds-tabs_scoped__nav" role="tablist">
      <li *ngFor="let tabName of ui.childTabNames; index as i"
          class="slds-tabs_scoped__item"
          [class.slds-is-active]="isTabActive(tabName)"
          role="presentation"
          title="">
        <a (click)="onTabClick(tabName)"
           [attr.aria-controls]="'tab-scoped-' + i"
           aria-selected="true"
           class="slds-tabs_scoped__link"
           href="javascript:void(0);"
           [id]="'tab-scoped-' + i + '__item'"
           role="tab"
           tabindex="0">{{getTabLabel(tabName)}}</a>
      </li>
    </ul>

    <div *ngIf="tabActive"
         class="slds-tabs_scoped__content"
         id="tab-scoped-0"
         role="tabpanel">
      <acc-data-table [records]="tabRecords" [ui]="tabActive"></acc-data-table>
    </div>

  </div>
</section>
